import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Tyre_maintenance = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  

  const canView  = hasPermission("Tyre Maintenance Details", "view");
    

  // Fetch branches only once
  useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/vehicle_details_report_own")
      .then((response) => {
        setBranches(response.data.branches);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, []);

  // Fetch data based on selected branch
  useEffect(() => {
    if (selectedBranch) {
        setLoading(true); 
      axios.get(`https://rfs2.infraconsoft.net.in/api/vehicle_details_report_own?branch_code=${selectedBranch}`)
        .then((response) => {
          setData(response.data.vehicles);
          setFilteredData(response.data.vehicles);
        })
        .catch((error) => {
          console.error("Error fetching vehicles:", error);
        })
        .finally(() => {
            setLoading(false); 
          });
    }
  }, [selectedBranch]);

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.vehicle_code && item.vehicle_code.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.vehicle_name && item.vehicle_name.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.vehicle_number && item.vehicle_number.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1); 
  };

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">{selectedBranch} - Tyre Maintenance - List</h2>
          <div>
            <Time />
          </div>
        </section>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by Vehicle code & Name" value={searchTerm} onChange={handleSearch} className="search-input" />
        </div>

        <div className="content-table">
          <table>
            <thead>
            <tr>
                <th>S.No</th>
                <th>Vehicle Code</th>
            <th>Vehicle Name</th>
            <th>Vehicle Number</th>
            <th>View Tyre</th>
              </tr>

            </thead>
            <tbody>
  {loading ? (
    <tr>
      <td colSpan="7" className="loading-text">Loading data, please wait...</td>
    </tr>
  ) : currentData.length > 0 ? (
    currentData.map((item, index) => (
      <tr key={index}>
        <td>{indexOfFirstItem + index + 1}</td>
       
        <td>{item.vehicle_code}</td>
        <td>{item.vehicle_name}</td>
        <td>{item.vehicle_number}</td>
        <td>
            <Link to={`/tyreadd_vehicle/${item.vehicle_basis}/${item.vehicle_code}/${item.branch_code}`}>Click</Link>
        </td>
       
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7">No Data Available</td>
    </tr>
  )}
</tbody>

          </table>
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>1</button>
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}> Next</button>
        </div>

      </div>
    </div>
  );
};

export default Tyre_maintenance;
